import { render, staticRenderFns } from "./DropdownBody.vue?vue&type=template&id=50e4064c&scoped=true"
import script from "./DropdownBody.vue?vue&type=script&lang=js"
export * from "./DropdownBody.vue?vue&type=script&lang=js"
import style0 from "./DropdownBody.vue?vue&type=style&index=0&id=50e4064c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e4064c",
  null
  
)

export default component.exports